import { CompanyType } from './company'
export enum UserRole {
  Customer = 'customer',
  AccountManager = 'account-manager',
}
import type { Brand } from './brand'

interface AccountManagerDTO {
  firstName: string
  lastName: string
  email: string
  avatarURL: string | null
}

export interface UserCompanyDTO {
  ID: string
  name: string
  brands: Brand[]
  accountManager?: AccountManagerDTO
}

interface CompanyBrandDTO {
  ID: string
  name: string
  label: string
}

interface AgencyLinkDTO {
  agencyID: string
  agencyBilled: boolean
}

export interface CompanyDTO {
  ID: string
  name: string
  billingID: string
  enable: boolean
  type: CompanyType
  brands: CompanyBrandDTO[]
  agencies: AgencyLinkDTO[]
}

export interface UserConfigRequestDTO {
  email: string
  firstName: string
  lastName: string
  role: UserRole
  companyIDs: string[]
}

export interface User {
  ID: string
  email: string
  firstname: string
  lastname: string
  avatarURL: string | null
  customerConfigID?: string | null
  brands?: Brand[]
  companies: UserCompanyDTO[]
  role: UserRole
  /** Product access keys. Not sent by the API yet — see use-sidebar-access.ts. */
  permissions?: string[]
}

export interface LoginPayload {
  username: string
  password: string
}

export interface LoginResponse {
  token: string
  user: {
    username: string
  }
}

export interface ResetPasswordDTO {
  password: string
  token: string
}

export interface ResetPasswordResponse {
  token: string
}

export interface ForgotPasswordDTO {
  email: string
}

export interface UserActivityDTO {
  email: string
  nbVisits: number
  nbActions: number
  maxActions: number
  sumVisitLength: number
  bounceCount: number
}

interface UserVisitDTO {
  date: string | null
  duration: number
  actions: number
  country: string
  device: string
  browser: string
  resolution: string
}

export interface UserProfileActivityDTO {
  email: string
  totalVisits: number
  totalActions: number
  totalVisitDuration: number
  firstVisit: string | null
  lastVisit: string | null
  devices: Record<string, number>
  countries: Record<string, number>
  browsers: Record<string, number>
  recentVisits: UserVisitDTO[]
}
